import React from 'react';
import ReactDOM from 'react-dom/client';
import './assets/style/style.css';

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.Fragment>
      <main>
          <h1>Line Development</h1>
          <h2>Frontend developer & UI design lover</h2>
          <h3>This website is under construction</h3>
          <p>
            You can check my projects on Github and follow me on LinkedIn
          </p>
          <p className="links">
            <a href="https://github.com/PaulineLesueur">Check my projects</a> - <a href="https://www.linkedin.com/in/pauline-lesueur/">Follow the witch</a>
          </p>
      </main>
  </React.Fragment>
);